"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResellerOnSelfStore = void 0;
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const jwt_decode_1 = require("jwt-decode");
const constants_1 = require("../../constants");
const utils_1 = require("../../../utils");
const extractPhoneNumber_1 = require("../../../utils/extractPhoneNumber");
const makeResellerInfoPath = (catalogSlug, businessUnit) => `/catalog/reseller/${catalogSlug}/?business_unit=${businessUnit}`;
const isResellerOnSelfStore = (catalogSlug) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!catalogSlug || (0, utils_1.isGenericReseller)(catalogSlug)) {
        return false;
    }
    const cookies = new universal_cookie_1.default();
    const resellerToken = cookies.get(constants_1.LOGGED_RESELLER_COOKIE_KEY);
    if (!resellerToken) {
        return false;
    }
    try {
        const decodedResellerJwt = (0, jwt_decode_1.jwtDecode)(resellerToken);
        const resellerPhoneFromToken = (_a = decodedResellerJwt.profile) === null || _a === void 0 ? void 0 : _a.whatsapp;
        if (!resellerPhoneFromToken) {
            return false;
        }
        const resellerInfoPath = makeResellerInfoPath(catalogSlug, utils_1.envToBusinessUnit[constants_1.CURRENT_BRAND]);
        const { data } = yield utils_1.apiClient.get(resellerInfoPath);
        if (!(data === null || data === void 0 ? void 0 : data.whatsapp)) {
            return false;
        }
        return (0, extractPhoneNumber_1.extractPhoneNumber)(data.whatsapp) === (0, extractPhoneNumber_1.extractPhoneNumber)(resellerPhoneFromToken);
    }
    catch (error) {
        return false;
    }
});
exports.isResellerOnSelfStore = isResellerOnSelfStore;
